import { Component, ViewChild } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { StatusEnum } from '@enums/Status';
import { Estimate } from '@interfaces/Estimate';
import { ExportProjectRequestDto } from '@interfaces/ExportProjectRequestDTO';
import { isNil } from 'lodash';
import { EstimatePickerComponent } from '../estimate-picker/estimate-picker.component';
import { EstimateImportService } from '../project-import/shared/estimate-import.service';

@Component({
  selector: 'pop-estimate-export',
  templateUrl: './estimate-export.component.html',
  styleUrls: ['./estimate-export.component.less']
})
export class EstimateExportComponent extends BaseComponent {
  @ViewChild('estimatePicker', { static: true })
  private estimatePicker?: EstimatePickerComponent;

  public resultsList: {
    titleKey: string;
    routerLink: string[];
    referenceCode: string;
  }[] = [];

  public selectedEstimate?: Estimate;

  private readonly showAllEstimates_key = 'EstimateImportComponent.showAllEstimates';
  private _showAllEstimates: boolean = sessionStorage.getItem(this.showAllEstimates_key) === 'true';
  public get showAllEstimates() {
    return this._showAllEstimates;
  }
  public set showAllEstimates(value: boolean) {
    this._showAllEstimates = value;
    sessionStorage.setItem(this.showAllEstimates_key, `${String(value)}`);
    this.updateFilter();
  }

  public canExportProject: boolean;
  public currentError?: string;
  public exportLoading = false;

  public constructor(private estimateImportService: EstimateImportService) {
    super();
  }

  public updateFilter() {
    this.estimatePicker?.filter();
  }

  public filterEstimates = ((dto: Estimate) => {
    if (this.showAllEstimates) {
      return dto.status === StatusEnum.Imported || dto.status === StatusEnum.Approved;
    }
    return !dto.hasPCSyncBeenRequested && dto.status === StatusEnum.Imported;
  }).bind(this); // this is passed by refernce. Bind is used to maintain the value of the keyword this

  public async selectedEstimateChange(estimate?: Estimate) {
    this.canExportProject = false;
    this.currentError = undefined;

    if (!estimate) {
      return;
    }

    this.exportLoading = true;
    this.currentError = await this.estimateImportService.canExportEstimate(estimate.estimateGroupId);
    this.canExportProject = isNil(this.currentError);
    this.exportLoading = false;
  }

  public async exportProject() {
    const dto: ExportProjectRequestDto = {
      estimateGroupId: this.selectedEstimate.estimateGroupId
    };

    const estimateId = await this.estimateImportService.exportToPc(dto);

    this.exportProjectSuccess(estimateId);
  }

  private exportProjectSuccess(estimateId: string) {
    let code: string;
    if (this.selectedEstimate.codeRef) {
      code = `${this.selectedEstimate.projectCode} ${this.selectedEstimate.codeRef}`;
    } else {
      code = this.selectedEstimate.projectCode;
    }

    this.resultsList.push({
      titleKey: 'DATA_MANAGEMENT.EXPORT_SUCCESS',
      routerLink: this.getEstimateRoute(estimateId),
      referenceCode: code
    });

    this.selectedEstimate = undefined;
  }

  public getEstimateRoute(estimateId?: string) {
    if (!estimateId) {
      return;
    }

    const routerLink = ['/app/', 'estimate-detail', estimateId];
    return routerLink;
  }

  public toggleShowAllEstimates() {
    this.selectedEstimate = undefined;
  }
}
